import { Mapper } from '@shared/helpers/mapper';
import { GridRow } from '@shared/models/grid/grid-row';

export function mapToGridRow<TData>(rows: TData[]): GridRow<TData>[] {
  return Mapper.mapByList(rows, GridRow<TData>, [
    {
      uuid: (_source: TData): string => crypto.randomUUID(),
      data: (source: TData): TData => source,
    },
  ]);
}
